import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_go_to_checkout_modal = _resolveComponent("go-to-checkout-modal")
  const _component_user_login_modal = _resolveComponent("user-login-modal")
  const _component_user_follow_settings_modal = _resolveComponent("user-follow-settings-modal")
  const _component_add_product_to_cart_modal_manager = _resolveComponent("add-product-to-cart-modal-manager")
  const _component_language_selector_modal = _resolveComponent("language-selector-modal")
  const _component_push_notification_modal = _resolveComponent("push-notification-modal")
  const _component_unauthenticated_user_follow_project_modal = _resolveComponent("unauthenticated-user-follow-project-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_go_to_checkout_modal),
    _createVNode(_component_user_login_modal),
    _createVNode(_component_user_follow_settings_modal),
    _createVNode(_component_add_product_to_cart_modal_manager),
    _createVNode(_component_language_selector_modal),
    _createVNode(_component_push_notification_modal),
    _createVNode(_component_unauthenticated_user_follow_project_modal)
  ], 64 /* STABLE_FRAGMENT */))
}